import { EMPTY } from "rxjs";
import { filter, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { PersistenceMode } from "../../../utils/PersistenceMode";
import { utilPersistence } from "../../../utils/utilPersistence";
import { utilServerPersistence } from "../../../utils/utilServerPersistence";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
export var epicGetServerPersistence = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionPlayerInfo.Received &&
            action.playerInfo !== undefined &&
            action.playerInfo.playerId !== undefined;
    }), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.PlayerPreferencesStorage,
            props: {
                playerId: action.playerInfo.playerId,
            },
        });
    }), retry(), switchMap(function (res) {
        (res.keyValues || []).forEach(function (value) {
            if (value.key !== undefined && value.value) {
                utilPersistence.setValue(value.key, utilServerPersistence.convertServerPersistenceValue(value.key, value.value), PersistenceMode.Write);
            }
        });
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/server-persistence/epics/epicGetServerPersistence.ts
// module id = 2326
// module chunks = 3